export default __webpack_public_path__ + "static/media/broderstorf-2.c30078ca.jpg";